import React, {Component, Fragment} from "react";
import "./QuotationSummary.css";
import {FormattedMessage} from "react-intl";
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import Framework from "../QuotationForm/StencilQuotationForm/StencilQuotationFormFields/Framework";
import Modal from "react-bootstrap/es/Modal";

const SummaryPanel = (props) => {
    return(
        <div className="summary-info">
            <div style={props.cssStylePCB}>
                <div className="title-1 responsive-heading-summary text-align-l quotation-page-titles">
                    <FormattedMessage id="app.quotation.summary.title"
                                      defaultMessage="PRINTED CIRCUIT BOARD MANUFACTURING SPECIFICATION"
                                      description=""/>
                </div>
                <br/>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.layer"
                                                          defaultMessage="Layer Structure"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.selectedPcbParams.layer}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.size"
                                                          defaultMessage="Size"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {(Math.floor(props.selectedPcbParams.width *10)/10).toFixed(1)} mm x {(Math.floor(props.selectedPcbParams.length *10) /10).toFixed(1)} mm
                        </p>
                    </div>
                </div>
                {/*<hr className="quotation-summary-hr"/>*/}

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.no.of.sheets"
                                                          defaultMessage="Number of Sheets"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.selectedPcbParams.qty}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.thickness"
                                                          defaultMessage="Thickness"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.selectedPcbParams.thickness}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.impedance"
                                                          defaultMessage="Impedance"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.impedence}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.color"
                                                          defaultMessage="Resist Color"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.color}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.pcb-quotation.silk-color"
                                                          defaultMessage="Silk Color"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {/*{silkColor}*/}
                            {props.silkColorFromColor}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.surface"
                                                          defaultMessage="Surface Finish"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.surface}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.copper"
                                                          defaultMessage="Copper Thickness"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.copperWeight}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.gold.fingers"
                                                          defaultMessage="Gold Fingers"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.goldFinger}
                        </p>
                    </div>
                </div>

                <div className="row summary-field-margin">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.material"
                                                          defaultMessage="Material"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left sm-text">
                            {props.materialDetails}
                        </p>
                    </div>
                </div>
                {/*<br/>*/}

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.imposition"
                                                          defaultMessage="Imposition Request by Kitcut"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.panelFlag}
                        </p>
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.substrate"
                                                          defaultMessage="Discarded Substrate"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.edgeRails}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6 alignment-quotation">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.imposition.size"
                                                          defaultMessage="Imposition Size"
                                                          description=""
                                        />
                                    </span>
                    </div>

                    <div className="6 custom-col-6">

                        <p className="price-info-static-text xy-size pull-left sm-text">
                            {props.edgeRailsValue===0 ?
                                <text>  X : {"("+ (props.selectedPcbParams.width + "x" +props.selectedPcbParams.panelByJLCPCB_X)+ ")" + "= " + Math.round((props.selectedPcbParams.width *props.selectedPcbParams.panelByJLCPCB_X)*100)/100}</text>:
                                props.edgeRailsValue ===1 && ((props.selectedPcbParams.width * props.selectedPcbParams.panelByJLCPCB_X) > (props.selectedPcbParams.length * props.selectedPcbParams.panelByJLCPCB_Y) || (props.selectedPcbParams.width * props.selectedPcbParams.panelByJLCPCB_X) === (props.selectedPcbParams.length * props.selectedPcbParams.panelByJLCPCB_Y))?
                                    <text>X : {"("+ (props.selectedPcbParams.width + "x" +props.selectedPcbParams.panelByJLCPCB_X) + ")" + "= " + Math.round((props.selectedPcbParams.width *props.selectedPcbParams.panelByJLCPCB_X)*100)/100}</text> :
                                    <text>X : {"("+ (props.selectedPcbParams.width + "x" +props.selectedPcbParams.panelByJLCPCB_X + "+20")+ ")" + "= " + Math.round((props.selectedPcbParams.width *props.selectedPcbParams.panelByJLCPCB_X+20)*100)/100}</text>
                            }

                            &nbsp;<br></br>
                            {props.edgeRailsValue === 0 ?
                                <text> Y : {"("+(props.selectedPcbParams.length + "x" + props.selectedPcbParams.panelByJLCPCB_Y) + ")" + "= " + Math.round((props.selectedPcbParams.length * props.selectedPcbParams.panelByJLCPCB_Y)*100)/100} </text> :
                                props.edgeRailsValue === 1 && ((props.selectedPcbParams.width * props.selectedPcbParams.panelByJLCPCB_X) > (props.selectedPcbParams.length * props.selectedPcbParams.panelByJLCPCB_Y) || (props.selectedPcbParams.width * props.selectedPcbParams.panelByJLCPCB_X) === (props.selectedPcbParams.length * props.selectedPcbParams.panelByJLCPCB_Y))?
                                    <text> Y : {"("+(props.selectedPcbParams.length + "x" + props.selectedPcbParams.panelByJLCPCB_Y+ "+20")+ ")" + "= " + Math.round((props.selectedPcbParams.length * props.selectedPcbParams.panelByJLCPCB_Y+20)*100)/100} </text> :
                                    <text> Y : {"("+(props.selectedPcbParams.length + "x" + props.selectedPcbParams.panelByJLCPCB_Y) + ")" + "= " + Math.round((props.selectedPcbParams.length * props.selectedPcbParams.panelByJLCPCB_Y)*100)/100} </text>
                            }
                        </p>


                    </div>
                </div>
                {/*<br/>*/}

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.flying"
                                                          defaultMessage="Flying Inspection"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.flyingProbe}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.castellation"
                                                          defaultMessage="Castellated Hole"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.castellated}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.mixed.appearance"
                                                          defaultMessage="Different Design"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.differentDesign}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.weight"
                                                          defaultMessage="Weight"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.totalWeight}g
                        </p>
                    </div>
                </div>
            </div>
            <br/>
            {/*PCB with stencil or Stencil only*/}
            <div className="summary-pcb-stencil" style={props.cssStyleStencil}>
                <div className="title-1 responsive-heading-summary text-align-l quotation-page-titles">
                    <FormattedMessage id="app.quotation.summary.title.metal-mask"
                                      defaultMessage="METAL MASK MANUFACTURING SPECIFICATION"
                                      description=""/>
                </div>
                <br/>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.framework"
                                                          defaultMessage="Framework"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.framework}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.dimension"
                                                          defaultMessage="Dimension"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.size}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.stencil.side"
                                                          defaultMessage="Stencil Side"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.stnclSide}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.stencil.qty"
                                                          defaultMessage="Stencil Qty"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.stnclQty}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.stencil.polishing"
                                                          defaultMessage="Electro polishing"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.elecPolish}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.stencil.fiducial"
                                                          defaultMessage="Fiducials"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.fiducials}
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.stencil.custom.size"
                                                          defaultMessage="Customized Size"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.customSize}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 custom-col-6">
                                    <span className="price-info-static-text">
                                        <FormattedMessage id="app.quotation.summary.weight"
                                                          defaultMessage="Weight"
                                                          description=""
                                        />
                                    </span>
                    </div>
                    <div className="col-md-6 custom-col-6">
                        <p className="price-info-static-text pull-left">
                            {props.totalWeight}g
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
class QuotationSummary extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showSummaryModal: false
        };
        this.showSummaryModal = this.showSummaryModal.bind(this);
        this.closeSummaryModal = this.closeSummaryModal.bind(this);
    }

    showSummaryModal = () => {
        this.setState({
            showSummaryModal : true
        }, ()=>{
            document.getElementById("price-summery-fixed").style.display = "none";
        })
    };
    closeSummaryModal = () => {
        this.setState({
            showSummaryModal : false
        }, ()=>{
            document.getElementById("price-summery-fixed").style.display = "block";
        })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.quotation !== this.props.quotation){
            let summaryDiv = document.getElementById('quotation-summary-div-resp-web');

            summaryDiv.classList.remove("quotation-summary-div-type-1", "quotation-summary-div-type-2");

            if(this.props.quotation.orderType === 1){
                summaryDiv.classList.add("quotation-summary-div-type-1");
            }else if(this.props.quotation.orderType === 2){
                summaryDiv.classList.add("quotation-summary-div-type-2");
            }
        }
    }

    render() {
        if(this.state.showSummaryModal){
            let summary =  document.getElementsByClassName("summary-fixed-z")[0];
            let pricing =  document.getElementsByClassName("pricing-fixed-z")[0];
            pricing.classList.replace("pricing-fixed-z", "pricing-fixed");
            summary.classList.replace("summary-fixed-z", "summary-fixed");
        }else {
            let summary =  document.getElementsByClassName("summary-fixed")[0];
            let pricing =  document.getElementsByClassName("pricing-fixed")[0];

            if(summary !== undefined){
                summary.classList.replace("summary-fixed", "summary-fixed-z");
            }
            if(pricing !== undefined){
                pricing.classList.replace("pricing-fixed", "pricing-fixed-z");
            }
        }
        let orderType = this.props.quotation.orderType;
        let selectedPcbParams = this.props.quotation.pcbParam;
        let selectedStencilParams = this.props.quotation.smtStencilParam;

        let colorValue = this.props.quotation.pcbParam.pcbColor;
        let surfaceValue = this.props.quotation.pcbParam.surfaceFinish;
        let copperValue = this.props.quotation.pcbParam.copperWeight;
        let goldFingerValue = this.props.quotation.pcbParam.goldFinger;
        let edgeRailsValue = this.props.quotation.pcbParam.edgeRails;
        let differentDesign = this.props.quotation.pcbParam.differentDesign;
        let flyingProbeValue = this.props.quotation.pcbParam.flyingProbe;
        let castellatedValue = this.props.quotation.pcbParam.castellatedHoles;
        let impedanceValue = this.props.quotation.pcbParam.impedance;
        let totalWeight = this.props.mainPriceInformation.weight;
        let frameWorkValue = this.props.quotation.smtStencilParam.framework;
        let dimension = this.props.quotation.smtStencilParam.dimensionsID;
        let stnclSideValue = this.props.quotation.smtStencilParam.stencilSide;
        let stnclQty = this.props.quotation.smtStencilParam.stencilQty;
        let elecPolishValue = this.props.quotation.smtStencilParam.electropolishing;
        let fiducialValue = this.props.quotation.smtStencilParam.fiducials;
        let cusSizeValue = this.props.quotation.smtStencilParam.customizeFlag;
        let panelFlagValue = this.props.quotation.pcbParam.panelFlag;
        let silkColorValue = this.props.quotation.pcbParam.silkColor;

        // let dimensions = this.props.quotation.pcbParam.width !== '' && this.props.quotation.pcbParam.length !== '' ?
        //     this.props.quotation.pcbParam.width + "mm*" + this.props.quotation.pcbParam.length + "mm" : '';
        let size;
        if(this.props.quotation.smtStencilParam.framework===0){
                 size = dimension === 112 ? "380×280（有効エリア290×190mm)" :
                    dimension === 501 ?  "420×320（有効エリア400×240mm)":
                        dimension === 502 ? "450×350（有効エリア420×270mm)" :
                            dimension === 503 ? "520×420（有効エリア490×340mm)" :
                                dimension === 504 ? "460×460（有効エリア430×380mm)" : '';

            } else {

             size = dimension === 2 ? "470×370（有効エリア290×190mm)" :
                dimension === 111 ?  "400×300（有効エリア240×140mm)":
                    dimension === 3 ? "520×420（有効エリア340×240mm)" :
                        dimension === 6 ? "550×450（有効エリア370×270mm)" :
                            dimension === 7 ? "584×584（有効エリア380×380mm)" :
                            dimension === 5 ? "650×550（有効エリア450×350mm)" :
                            dimension === 124 ? "700×500（有効エリア500×320mm)" :
                            dimension === 108 ? "600×400（有効エリア400×220mm)" :
                            dimension === 8 ? "736×736（有効エリア500×500mm)" :
                            dimension === 3 ? "520×420（有効エリア340×240mm)" :
                            dimension === 109 ? "800×400（有効エリア600×220mm)" :
                            dimension === 114 ? "800×500（有効エリア600×320mm)" :
                            dimension === 110 ? "1000×400（有効エリア760×220mm)" : '';
        }

        let silkColor = silkColorValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                                                 defaultMessage="White" description=""/> :
           silkColorValue === 2 ?  <FormattedMessage id="app.pcb-quotation.pcb-color-black"
                                                     defaultMessage="Black" description=""/> : '';

        let silkColorFromColor = colorValue === 0 ? <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                                                      defaultMessage="White" description=""/> :
            colorValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                                 defaultMessage="White" description=""/> :
                colorValue === 2 ? <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                                     defaultMessage="White" description=""/> :
                    colorValue === 3 ? <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                                         defaultMessage="White" description=""/> :
                        colorValue === 4 ? <FormattedMessage id="app.pcb-quotation.pcb-color-black"
                                                             defaultMessage="Black" description=""/> :
                            colorValue === 5 ? <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                                                 defaultMessage="White" description=""/> : '';

        let color = colorValue === 0 ? <FormattedMessage id="app.home-content.pcb-service.service-green"
                                                         defaultMessage="Green"
                                                         description=""/> :
            colorValue === 1 ? <FormattedMessage id="app.home-content.pcb-service.service-red"
                                                 defaultMessage="Red"
                                                 description=""/> :
                colorValue === 2 ? <FormattedMessage id="app.home-content.pcb-service.service-yellow"
                                                     defaultMessage="Yellow"
                                                     description=""/> :
                    colorValue === 3 ? <FormattedMessage id="app.home-content.pcb-service.service-blue"
                                                         defaultMessage="Blue"
                                                         description=""/> :
                        colorValue === 4 ? <FormattedMessage id="app.home-content.pcb-service.service-white"
                                                             defaultMessage="White"
                                                             description=""/> :
                            colorValue === 5 ? <FormattedMessage id="app.home-content.pcb-service.service-black"
                                                                 defaultMessage="Black"
                                                                 description=""/> : '';

        let surface = surfaceValue === 0 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-1"
                                                             defaultMessage="HASL(with lead)"
                                                             description=""/> :
            surfaceValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-2"
                                                   defaultMessage="LeadFree HASL+RoHS"
                                                   description=""/> :
                surfaceValue === 2 ? <FormattedMessage id="app.pcb-quotation.pcb-surface-finish-3"
                                                       defaultMessage="ENIG-RoHS"
                                                       description=""/> : '';

        let panelFlag = panelFlagValue === 0 ? <FormattedMessage id="app.pcb-quotation.panel-flag-no"
                                                                 defaultMessage="No"
                                                                 description=""/> :
            panelFlagValue === 1 ? <FormattedMessage id="app.pcb-quotation.panel-flag-yes"
                                                     defaultMessage="Yes"
                                                     description=""/> : '';

        let goldFinger = goldFingerValue === 0 ? <FormattedMessage id="app.pcb-quotation.pcb-gold-fingers-no"
                                                                   defaultMessage="No" description=""/> :
            <FormattedMessage id="app.pcb-quotation.pcb-gold-fingers-yes"
                              defaultMessage="Yes (45 chamfered border)" description=""/>;

        if (panelFlagValue === 0) {
            edgeRailsValue = 0;
        }

        let edgeRails = edgeRailsValue === 0 ? <FormattedMessage id="app.pcb-quotation.pcb-edge-rails-no"
                                                                 defaultMessage="No" description=""/> :
            <FormattedMessage id="app.pcb-quotation.pcb-edge-rails-yes"
                              defaultMessage="Yes" description=""/>;


        let copperWeight = copperValue === 1 ? "35 μm" :
            copperValue === 2 ? "70 μm" : '';

        // let goldFingers = goldFingerValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-gold-fingers-no"
        //                                                             defaultMessage="No" description=""/> :
        //     goldFingerValue === 2 ? <FormattedMessage id="app.pcb-quotation.pcb-gold-fingers-yes"
        //                                               defaultMessage="Yes (45 chamfered border)"
        //                                               description=""/> : '';

        let materialDetails = this.props.quotation.pcbParam.materialDetails === 0 ?
            <FormattedMessage id="app.pcb-quotation.pcb-material-details-standard-tg"
                              defaultMessage="FR4 - Standard Tg 140C"
                              description=""/> : '';
        let flyingProbe = flyingProbeValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-flying-probe-fully-test"
                                                                     defaultMessage="Fully Test"
                                                                     description=""/> :
            flyingProbeValue === 2 ? <FormattedMessage id="app.pcb-quotation.pcb-flying-probe-not-test"
                                                       defaultMessage="Not Test"
                                                       description=""/> : '';
        let castellated = castellatedValue === 0 ? <FormattedMessage id="app.pcb-quotation.pcb-castellated-holes-no"
                                                       defaultMessage="No"
                                                       description=""/> :
            <FormattedMessage id="app.pcb-quotation.pcb-castellated-holes-yes"
                              defaultMessage="Yes"
                              description=""/>;

        let framework = frameWorkValue === 1 ? "あり" :
            "なし";

        let elecPolish = elecPolishValue === 1 ?
            <FormattedMessage id="app.stencil-quotation.stencil-electropolishing-yes"
                              defaultMessage="Yes"
                              description=""/> :
            <FormattedMessage id="app.stencil-quotation.stencil-electropolishing-no"
                              defaultMessage="No" description=""/>;

        let fiducials = fiducialValue === 0 ? <FormattedMessage id="app.stencil-quotation.stencil-fiducials-1"
                                                                defaultMessage="No Fiducial"
                                                                description=""/> :
            fiducialValue === 1 ?
                <FormattedMessage id="app.stencil-quotation.stencil-fiducials-2"
                                  defaultMessage="Etched Through" description=""/> :

                <FormattedMessage id="app.stencil-quotation.stencil-fiducials-3"
                                  defaultMessage="Etched Through" description=""/>;

        let stnclSide = stnclSideValue === 0 ? <FormattedMessage id="app.stencil-quotation.stencil-side-1"
                                                                 defaultMessage="Top+Bottom(On Single Stencil)"
                                                                 description=""/> :
            stnclSideValue === 1 ? <FormattedMessage id="app.stencil-quotation.stencil-side-2"
                                                     defaultMessage="Top"
                                                     description=""/> :
                stnclSideValue === 2 ? <FormattedMessage id="app.stencil-quotation.stencil-side-3"
                                                         defaultMessage="Bottom"
                                                         description=""/> :
                    <FormattedMessage id="app.stencil-quotation.stencil-side-4"
                                      defaultMessage="Top+Bottom(On Separate Stencil)"
                                      description=""/>;

        if (frameWorkValue === 1) { // yes
            cusSizeValue = 0;
        }
        let customSize = cusSizeValue === 1 ?
            <div>
                X : {this.props.quotation.smtStencilParam.customizeSizeX}mm x
                Y : {this.props.quotation.smtStencilParam.customizeSizeY}mm
            </div>:

            <FormattedMessage id="app.stencil-quotation.stencil-size-no"
                              defaultMessage="No"
                              description=""/>;

        let impedence = impedanceValue === 1 ? <FormattedMessage id="app.pcb-quotation.pcb-impedance-no"
                                                                 defaultMessage="No" description=""/> :
            <FormattedMessage id="app.pcb-quotation.pcb-impedance-yes"
                              defaultMessage="Yes" description=""/>;

        let cssStylePCB = {display: 'block'};
        let cssStyleStencil = {display: 'none'};

        if (orderType === 2) {
            cssStylePCB = {display: 'block'};
            cssStyleStencil = {display: 'block'};
        } else if (orderType === 3) {
            cssStyleStencil = {display: 'block'};
            cssStylePCB = {display: 'none'};
        } else {
            cssStylePCB = {display: 'block'};
            cssStyleStencil = {display: 'none'};
        }

        if (panelFlagValue === 0) {
            selectedPcbParams.panelByJLCPCB_X = 0;
            selectedPcbParams.panelByJLCPCB_Y = 0;
        }/*
        if(frameWorkValue === 1){
            selectedStencilParams.customizeFlag = 0;
        }*/

        // InitialQuotationState.heightSet={
        //     height : InitialQuotationState.quotationSumHeight
        // };

        if(InitialQuotationState.heightSet.height>0){
            InitialQuotationState.heightSet={
            };
        }else{
            InitialQuotationState.heightSet={
                height : InitialQuotationState.quotationSumHeight

            };
        }

        return (
           <Fragment>
               <div className=" quotation-summary-div web-view" id="quotation-summary-div-resp-web" style={InitialQuotationState.heightSet}>
                   {/*<div className=" quotation-summary-div" style={InitialQuotationState.heightSet}>*/}
                   {/*<div className={InitialQuotationState.qsdcls + " quotation-summary-div"}>*/}

                   <SummaryPanel
                       selectedPcbParams = {selectedPcbParams}
                       cssStylePCB = {cssStylePCB}
                       impedence = {impedence}
                       color = {color}
                       silkColorFromColor = {silkColorFromColor}
                       surface = {surface}
                       copperWeight = {copperWeight}
                       goldFinger = {goldFinger}
                       materialDetails = {materialDetails}
                       panelFlag = {panelFlag}
                       edgeRails = {edgeRails}
                       edgeRailsValue = {edgeRailsValue}
                       flyingProbe = {flyingProbe}
                       castellated = {castellated}
                       differentDesign = {differentDesign}
                       totalWeight = {totalWeight}
                       cssStyleStencil = {cssStyleStencil}
                       framework = {framework}
                       size = {size}
                       stnclSide = {stnclSide}
                       stnclQty = {stnclQty}
                       elecPolish = {elecPolish}
                       fiducials = {fiducials}
                       customSize = {customSize}

                   />

                   {/*</div>*/}

                   {/* <h1>Right Testing</h1> */}

               </div>
               {/*//////////////////////////////////*/}
               <div className="mobile-view summary-fixed-z">
                   <div className="row">
                       <div className="custom-col-6 resp-pricing" onClick={this.props.showPricingModal}>料金詳細</div>
                       <div className="custom-col-6" onClick={this.showSummaryModal}>基板製造仕様</div>

                   </div>
               </div>

               {/*summary modal ------------------------------*/}
               <Modal dialogClassName="options-modal" show={this.state.showSummaryModal}
                      onHide={this.closeSummaryModal}>
                   <Modal.Header closeButton>
                       <div className="quotation-page-titles">
                           基板製造仕様
                       </div>
                   </Modal.Header>
                   <Modal.Body>
                       <SummaryPanel
                           selectedPcbParams = {selectedPcbParams}
                           cssStylePCB = {cssStylePCB}
                           impedence = {impedence}
                           color = {color}
                           silkColorFromColor = {silkColorFromColor}
                           surface = {surface}
                           copperWeight = {copperWeight}
                           goldFinger = {goldFinger}
                           materialDetails = {materialDetails}
                           panelFlag = {panelFlag}
                           edgeRails = {edgeRails}
                           edgeRailsValue = {edgeRailsValue}
                           flyingProbe = {flyingProbe}
                           castellated = {castellated}
                           differentDesign = {differentDesign}
                           totalWeight = {totalWeight}
                           cssStyleStencil = {cssStyleStencil}
                           framework = {framework}
                           size = {size}
                           stnclSide = {stnclSide}
                           stnclQty = {stnclQty}
                           elecPolish = {elecPolish}
                           fiducials = {fiducials}
                           customSize = {customSize}

                       />
                   </Modal.Body>
                   <Modal.Footer>
                       <div className="col-md-12">

                           <button className="btn btn-primary col-md-2 pull-right"
                                   onClick={this.closeSummaryModal}>
                               閉じる
                           </button>
                       </div>
                   </Modal.Footer>
               </Modal>

           </Fragment>
        );
    }
}

export default QuotationSummary;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationSummary/QuotationSummary.js